
export async function activeMembership( params ) {
  var today = new Date();
  const membershipExpiration = params.memberships[0].termEndDate;
  if ( membershipExpiration === null ) {
    // Return true;
  }
  const expDate = new Date( membershipExpiration );
  if ( expDate >= today ) {
    return true;
  }
  return false;
}